import React from 'react';
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  makeStyles
} from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Enum_Action_Button_Enum } from '@hooks/useUserActionLog';
import { CapaQuotationServiceType } from '@generated/graphql';
export interface CapabilityCardProps {
  img: string;
  label: string;
  isSelected?: boolean;
  log?: Enum_Action_Button_Enum;
  serviceType?: CapaQuotationServiceType;
}

const CapabilityCard: React.FC<CapabilityCardProps> = ({
  img,
  label,
  isSelected
}) => {
  const { container, cardContainer, cardImage, cardContent } = useStyles({
    isSelected: isSelected
  });
  return (
    <Box className={container}>
      <Card classes={{ root: cardContainer }}>
        <CardMedia className={cardImage} image={img} />
        <CardContent classes={{ root: cardContent }}>
          <CustomizedTypography
            variant={'h4'}
            fontWeight="500"
            color={isSelected ? 'primary' : 'textPrimary'}
          >
            <i className="request-gtm-serviceType-btn">{label}</i>
          </CustomizedTypography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CapabilityCard;

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      '& .MuiCardContent-root': {
        transition: '0.3s',
        backgroundColor: colorSet.gray400
      }
    }
  },
  cardContainer: {
    width: 179,
    height: 211,
    fontSize: '18px',
    borderRadius: 16,
    boxShadow: 'unset'
  },
  cardContent: (props: { isSelected?: boolean }) => ({
    display: 'flex',
    height: 65,
    boxSize: 'border-box',
    justifyContent: 'center',
    alignContent: 'center',
    backgroundColor: colorSet.gray300,
    padding: 0,
    '& h4': {
      lineHeight: '57px'
    },
    '& p': {
      lineHeight: '49px'
    },
    [theme.breakpoints.down('md')]: {
      minHeight: 80
    },
    '&:last-child': {
      paddingBottom: 0
    }
  }),
  cardImage: {
    width: 179,
    height: 145
  }
}));
